/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { PersonDtoModel } from '../../crm/person-dto.model';
import {JSONable} from "@irian-ro/abstract-resource";

export class SignupFirstContactDto extends JSONable{
  personDTO: PersonDtoModel | undefined = undefined;
  phoneNumber: string | undefined = undefined;
  email: string | undefined = undefined;
  visiblityType: string | undefined = undefined;
  businessProfileUuid: string | undefined = undefined;
  receivesRequests: boolean | undefined = undefined;
  contactMethod: string | undefined = undefined;
  department: string | undefined = undefined;
  validFrom: string | undefined = undefined;
  validTo: string | undefined = undefined;
  legalEntityUuid: string | undefined = undefined;
}
